import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  paymentBlock: {
    marginBottom: '20px'
  },
  unitPrice: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  unitPriceTitle: {},
  unitPriceData: {
    fontSize: '40px',
    paddingLeft: '24px',
    marginLeft: '24px',
    borderLeft: "1px solid ".concat(palette.shades[300]),
    fontFamily: palette.fontFamilies.poppins,
    '& b': {
      display: 'block'
    },
    '& s': {
      display: 'block',
      color: palette.shades[600],
      fontSize: '18px',
      marginTop: '-5px',
      fontWeight: '600'
    }
  },
  selectPayoutMethodItem: {
    display: 'block',
    '& i': {
      display: 'block',
      fontSize: '12px',
      fontStyle: 'normal'
    },
    '&.disabled': {
      '&:hover': {
        backgroundColor: 'unset',
        cursor: 'default'
      }
    }
  }
}));
export default useStyles;